module.exports = __webpack_public_path__ + "img/Map.3dcf3f49.jpg";